module.exports = __webpack_public_path__ + "static/media/money.6dc8295d.svg";